let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("23xSi")).then(() => parcelRequire('8ymsB'));